import { useSearchParams } from 'react-router-dom'

/** One-off debug: `?lineGuides=1` (also `line-guides=1`) — colored stripes between text lines. */
export function useResumeLineGuidesMode(): boolean {
  const [searchParams] = useSearchParams()
  return searchParams.get('lineGuides') === '1' || searchParams.get('line-guides') === '1'
}
